import React, { useEffect, useRef } from 'react';
import { appConfig } from '@oneview/config';
import { getPublicPath } from '@/utils';
import { useDialog } from '../useDialog/useDialog';

type CacheBusterProps = {
    disabled?: boolean;
    currentVersion: string;
    newVersion: () => Promise<string>;
    pollIntervalMs?: number;
};

export const CacheBuster: React.FunctionComponent<CacheBusterProps> = ({
    disabled,
    currentVersion,
    newVersion,
    pollIntervalMs = appConfig.dataRefreshIntervalLong,
}) => {
    const timerRef = useRef<number>(0);

    const showUpdateDialog = useDialog({
        title: 'New Version Available',
        content: `We've made some improvements! Update now to access the latest features. If you don't save your changes, you might lose them.`,
        confirmationText: 'Update now',
        cancellationText: 'Later',
        confirmationButtonProps: {
            onClick: () => {
                window.location.replace(getPublicPath(true));
            },
        },
    });

    useEffect(() => {
        if (disabled) return;

        const check = async () => {
            try {
                const latest = await newVersion();
                if (latest && latest !== currentVersion) {
                    showUpdateDialog();
                    window.clearInterval(timerRef.current);
                }
            } catch {
                // tolerate transient network errors; the next tick retries
            }
        };

        check();
        timerRef.current = window.setInterval(check, pollIntervalMs);

        return () => window.clearInterval(timerRef.current);
        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
